import React from 'react';
import {Tabs} from 'antd-mobile';

export interface DeliveryTab {
    key: string;
    title: string;
    count?: number;
}

interface DeliveryTabsProps {
    tabs: DeliveryTab[];
    activeKey: string;
    onChange: (key: string) => void;
}

const DeliveryTabs: React.FC<DeliveryTabsProps> = ({tabs, activeKey, onChange}) => {
    return (
        <div className="bg-white border-b border-gray-200">
            <Tabs
                activeKey={activeKey}
                onChange={onChange}
            >
                {tabs.map(tab => (
                    <Tabs.Tab
                        key={tab.key}
                        title={
                            <div className="flex items-center justify-center">
                                {tab.title}
                                {tab.count !== undefined && (
                                    <span className="ml-1 text-gray-500">({tab.count})</span>
                                )}
                            </div>
                        }
                    />
                ))}
            </Tabs>
        </div>
    );
};

export default DeliveryTabs; 